import { buildCatalogUrl } from '@/shared/utils/buildCatalogUrl';

import type { ILawyerCardInfo } from '@/entities/lawyer/@x/journal';
import type { ArticleLawyersSection } from '@/pages/journalArticle/model/types/articleLawyers';

export const groupLawyersByCategories = (
  lawyers: ILawyerCardInfo[],
  topicId: number,
): ArticleLawyersSection[] => {
  const sections = new Map<number, ArticleLawyersSection>();

  lawyers.forEach((lawyer) => {
    const topicCategories = (lawyer.mainCategory ?? []).filter(
      (category) => category.topic_id === topicId,
    );

    topicCategories.forEach((category) => {
      const existing = sections.get(category.id);
      if (existing) {
        existing.lawyers.push(lawyer);
        return;
      }
      sections.set(category.id, {
        categoryId: category.id,
        catalogLink: buildCatalogUrl({ segments: [category.slug] }),
        lawyers: [lawyer],
      });
    });
  });

  return [...sections.values()];
};
